export const STEPS = {
    index: 'index',
    haus1: 'haus-step1',
    haus2: 'haus-step2',
    haus3: 'haus-step3',
    haus4: 'haus-step4',
    final: 'final',
    wohnung1: 'wohnung-step1',
    wohnung2: 'wohnung-step2',
    wohnung3: 'wohnung-step3',
    wohnung4: 'wohnung-step4',
    wohnung5: 'wohnung-step5'
}
